 import React, { useEffect, useState } from "react";
import "./Dashboard.css";
import API from "../services/api";
 

const roleOptions = ["SUPER_ADMIN", "HR_ADMIN", "CONTENT_MANAGER"];

const Dashboard = () => {
  const [admins, setAdmins] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    email: "",
    password: "",
    role: "",
  });

  const [editing, setEditing] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  // ✅ FETCH ADMINS
  useEffect(() => {
    fetchAdmins();
  }, []);

  const fetchAdmins = async () => {
  try {
    const res = await API.get("/admin/all/admins");

    console.log("API RESPONSE:", res.data);   // ⭐ DEBUG

    setAdmins(res.data.data || res.data);     // ⭐ FIX
  } catch (err) {
    console.log(err);
  }
};

  const resetForm = () => {
    setFormData({ id: null, name: "", email: "", password: "", role: "" });
    setEditing(false);
    setIsModalOpen(false);
    setErrorMessage("");
  };

  const handleChange = (e) => {
    setErrorMessage("");
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ✅ CREATE ADMIN
  const handleCreate = async () => {
    try {
      await API.post("/admin/create-admin", {
        username: formData.name.trim(),
        email: formData.email.trim(),
        password: formData.password,
        role: formData.role.trim(),
      });

      fetchAdmins();
      resetForm();
    } catch (err) {
      const backendErrors = err?.response?.data?.errors;
      const backendMessage = err?.response?.data?.message;

      if (Array.isArray(backendErrors) && backendErrors.length > 0) {
        setErrorMessage(backendErrors.join(" "));
        return;
      }

      setErrorMessage(backendMessage || "Failed to create admin");
    }
  };

  // ✅ EDIT
  const handleEdit = (admin) => {
    setFormData({
      id: admin.id,
      name: admin.username,
      email: admin.email,
      password: "",
      role: admin.role,
    });
    setEditing(true);
    setIsModalOpen(true);
  };

  // ✅ UPDATE ADMIN
  const handleUpdate = async () => {
    try {
      await API.put(`/admin/update-admin/${formData.id}`, {
        username: formData.name.trim(),
        email: formData.email.trim(),
        password: formData.password,
        role: formData.role.trim(),
      });

      fetchAdmins();
      resetForm();
    } catch (err) {
      const backendErrors = err?.response?.data?.errors;
      const backendMessage = err?.response?.data?.message;

      if (Array.isArray(backendErrors) && backendErrors.length > 0) {
        setErrorMessage(backendErrors.join(" "));
        return;
      }

      setErrorMessage(backendMessage || "Failed to update admin");
    }
  };

  // ✅ DELETE ADMIN
  const handleDelete = async (id) => {
    try {
      await API.delete(`/admin/delete-admin/${id}`);
      fetchAdmins();
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    editing ? handleUpdate() : handleCreate();
  };

  const openCreateModal = () => {
    setEditing(false);
    setFormData({ id: null, name: "", email: "", password: "", role: "" });
    setIsModalOpen(true);
  };

  return (
    <div className="admin-dashboard">
      <div className="dashboard-head">
        <h2 className="logo">Users Dashboard</h2>
        <button className="create-btn" onClick={openCreateModal}>
          Create User
        </button>
      </div>

      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Role</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {admins.map((admin) => (
              <tr key={admin.id}>
                <td>{admin.id}</td>
                <td>{admin.username}</td>
                <td>{admin.email}</td>
                <td>{admin.role}</td>
                <td className="table-actions">
                  <button
                    className="edit-btn"
                    onClick={() => handleEdit(admin)}
                  >
                    Edit
                  </button>

                  <button
                    className="delete-btn"
                    onClick={() => handleDelete(admin.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={resetForm}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <div className="modal-head">
              <h3>{editing ? "Update User" : "Create User"}</h3>
              <button className="modal-close" onClick={resetForm}>
                x
              </button>
            </div>

            <form className="modal-form" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />

              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />

              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                required
              >
                <option value="">Select Role</option>
                {roleOptions.map((role) => (
                  <option key={role}>{role}</option>
                ))}
              </select>

              {errorMessage && <p className="form-error">{errorMessage}</p>}

              <div className="modal-actions">
                <button
                  type="button"
                  className="modal-action-btn modal-action-btn-secondary"
                  onClick={resetForm}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="modal-action-btn modal-action-btn-primary"
                >
                  {editing ? "Update User" : "Create User"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
